export const DOCUMENT_TYPES = [
  "Ticket",
  "Voucher",
  "Programme",
  "Itinerary",
  "Quote",
  "Invoice",
  "Receipt / Proof of Payment",
  "Flight",
  "Reservation / Booking Confirmation",
  "Accommodation Confirmation",
  "Rate Sheet",
  "Passport / ID",
  "Visa Letter",
  "Insurance",
  "Indemnity / Terms",
  "Contract / Agreement",
  "Correspondence",
  "Other",
] as const;

export type DocumentType = (typeof DOCUMENT_TYPES)[number];

/** Map legacy/AI free-text values onto a canonical option where possible. */
export const normalizeDocumentType = (value?: string | null): string => {
  if (!value) return "";
  const v = value.trim();
  if (!v) return "";
  const exact = DOCUMENT_TYPES.find((t) => t.toLowerCase() === v.toLowerCase());
  if (exact) return exact;

  const key = v.toLowerCase().replace(/[_-]+/g, " ").trim();
  const aliases: Record<string, string> = {
    ticket: "Ticket",
    tickets: "Ticket",
    "e-ticket": "Ticket",
    eticket: "Ticket",
    voucher: "Voucher",
    vouchers: "Voucher",
    programme: "Programme",
    program: "Programme",
    itinerary: "Itinerary",
    "tour detail": "Itinerary",
    "tour details": "Itinerary",
    quote: "Quote",
    quotation: "Quote",
    invoice: "Invoice",
    "tax invoice": "Invoice",
    receipt: "Receipt / Proof of Payment",
    "proof of payment": "Receipt / Proof of Payment",
    pop: "Receipt / Proof of Payment",
    flight: "Flight",
    "flight ticket": "Flight",
    "boarding pass": "Flight",
    reservation: "Reservation / Booking Confirmation",
    "booking confirmation": "Reservation / Booking Confirmation",
    booking: "Reservation / Booking Confirmation",
    confirmation: "Reservation / Booking Confirmation",
    "accommodation confirmation": "Accommodation Confirmation",
    "hotel confirmation": "Accommodation Confirmation",
    "rate sheet": "Rate Sheet",
    rates: "Rate Sheet",
    passport: "Passport / ID",
    id: "Passport / ID",
    "id document": "Passport / ID",
    visa: "Visa Letter",
    "visa letter": "Visa Letter",
    insurance: "Insurance",
    indemnity: "Indemnity / Terms",
    terms: "Indemnity / Terms",
    "terms and conditions": "Indemnity / Terms",
    contract: "Contract / Agreement",
    agreement: "Contract / Agreement",
    correspondence: "Correspondence",
    email: "Correspondence",
    letter: "Correspondence",
    document: "Other",
    other: "Other",
  };
  return aliases[key] || v;
};
